<template lang="pug">
#diagnostico-socioambiental
    section.diagnostico-socioambiental__resultado
        .diagnostico-socioambiental__resultado__header
            .el-icon-arrow-left.mr-2(
                @click='voltar',
                style='font-size: 24px; cursor: pointer'
            )
            h1 {{ $t('mensagens.diagnosticoSocioambiental.titulo') }}

        .diagnostico-socioambiental__resultado__body
            section
                h3
                    i.flow.flow-shape.mr-2
                    b {{ $t('mensagens.diagnosticoSocioambiental.territorio') }}
                span {{ territorio.dadosTerritorio.nome }}

                .mb-3.mt-3(v-if='informacoes_gerais !== null')
                    h4.mb-3 {{ $t('mensagens.diagnosticoSocioambiental.informacoesGerais') }}:
                    h4.mb-3.informacoes-gerais(
                        v-if='informacoes_gerais.situacao'
                    ) {{ $t('mensagens.diagnosticoSocioambiental.situacao') }}: {{ validaSituacao(informacoes_gerais.situacao) }}
                    h4.mb-3.informacoes-gerais(
                        v-if='areaValue'
                    ) {{ areaLabel }}: {{ areaValue }}
                    h4.mb-3.informacoes-gerais(v-if="usuarioLogado.paisGrupo !=='PY'") {{ $t('mensagens.diagnosticoSocioambiental.bioma') }}: {{ informacoes_gerais.bioma ? informacoes_gerais.bioma : '--' }}
                    h4.mb-3.informacoes-gerais(v-if="usuarioLogado.paisGrupo !=='PY'") {{ $t('mensagens.diagnosticoSocioambiental.faixaDeFronteira') }}: {{ informacoes_gerais.faixa_fronteira !== null ? (informacoes_gerais.faixa_fronteira ? $t('mensagens.comuns.sim') : $t('mensagens.comuns.nao')) : '--' }}
                    h4.mb-3.informacoes-gerais(v-if="exibirAreaAgricultavel") {{ $t('mensagens.diagnosticoSocioambiental.areaAgricultavel') }}: {{ informacoes_gerais.areaAgricultavelHaFormatada ? informacoes_gerais.areaAgricultavelHaFormatada : '--' }}

                div.d-flex.flex-column(v-if='protocolos.length === 1 && selectedProtocolo && !consultaRealizada')
                    h3.font-weight-bold.mb-1 {{ $t('mensagens.diagnosticoSocioambiental.protocoloUtilizado') }}
                    el-select(
                        :disabled='protocolos.length === 1',
                        v-model='selectedProtocolo'
                    )
                        el-option(
                            v-for='protocolo in protocolos',
                            :key='protocolo.codigo',
                            :label='protocolo.descricao',
                            :value='protocolo.codigo'
                        )

                div.d-flex.flex-column(v-if='protocolos.length > 1 && !consultaRealizada')
                    b {{ $t('mensagens.diagnosticoSocioambiental.selecioneProtocoloParaAnalisar') }}
                    el-select(
                        :disabled='protocolos.length === 1',
                        v-model='selectedProtocolo'
                    )
                        el-option(
                            v-for='protocolo in protocolos',
                            :key='protocolo.codigo',
                            :label='protocolo.descricao',
                            :value='protocolo.codigo'
                        )

                BaseButton.align-self-center.w-100.my-3(
                    v-if='!consultaRealizada'
                    type='primary',
                    size='large',
                    key='btnRealizarDiagnostico',
                    @click='buscarDiagnostico'
                ) Realizar diagnóstico socioambiental

                div(v-if='consultaRealizada && protocoloUtilizadoFormatado')
                    h3.font-weight-bold.mb-3 {{ $t('mensagens.diagnosticoSocioambiental.protocoloUtilizado') }}
                    p {{ protocoloUtilizadoFormatado }}

                div(v-if='consultaRealizada')
                    h3.font-weight-bold {{ $t('mensagens.diagnosticoSocioambiental.resultadoDaAnalise') }}

                    DiagnosticoSocioambiental.mb-3(
                        v-if='refMapa',
                        style='padding: 0; display: grid',
                        :dadosConsulta='territorio',
                        :habilitar-opacidade='true',
                        :habilitar-sinal-aviso='true',
                        @index-aberto='atualizarRestricaoMapa',
                        :mapaLeaflet='refMapa',
                        :habilitar-zoom-restricao='true'
                    )

            section.mt-3(v-if='territorio.buffer && consultaRealizada')
                h3.mb-3
                    i.el-icon-connection.mr-2
                    b {{ tituloProximidade }}

                DiagnosticoSocioambiental.mb-3(
                    v-if='refMapa',
                    style='padding: 0; display: grid',
                    :dadosConsulta='territorio.buffer',
                    :habilitar-sinal-aviso='territorio.buffer.habilitarAlertaProximidade',
                    @index-aberto='atualizarRestricaoBufferMapa',
                    :mapaLeaflet='refMapa',
                    :habilitar-zoom-restricao='true'
                )

            section.mb-3(v-if='consultaRealizada && !ambientePy')
                div(v-for='(representante, index) in representantes')
                    h3
                        i.flow.flow-user-second.mr-2
                        b {{ $t('mensagens.diagnosticoSocioambiental.pessoa') }}
                    span {{ representante.nomeRepresentante }}

                    DiagnosticoSocioambiental.mb-3.mt-3(
                        v-if='refMapa',
                        style='padding: 0; display: grid',
                        :indexCollapse='index',
                        :dadosConsulta='representante',
                        :cpfCnpj='representante.documento',
                        :habilitar-opacidade='true',
                        :habilitar-sinal-aviso='true',
                        @index-aberto='atualizarRestricaoMapaCpf',
                        :mapaLeaflet='refMapa',
                        :habilitar-zoom-restricao='true'
                    )

            section.mb-3(v-if='consultaRealizada')
                div(v-for='(car, index) in dadosCar')
                    h3
                        i.flow.flow-shape.mr-2
                        b {{ $t('mensagens.diagnosticoSocioambiental.car') }}
                    div.d-flex.flex-column
                        span.mb-3 {{ car.imovel.codigo }}

                        div.mb-3
                            h4.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.dataAtualizacaoDados') }}: {{ car.camadaCar.dataAtualizacaoDados ? car.camadaCar.dataAtualizacaoDados : '--' }}

                    DiagnosticoSocioambiental.mb-3.mt-3(
                        v-if='refMapa',
                        :mapaLeaflet='refMapa',
                        style='padding: 0; display: grid',
                        :indexCollapse='index',
                        :dadosConsulta='car',
                        :habilitar-opacidade='true',
                        :habilitar-sinal-aviso='true',
                        v-bind:car='getCar(car.imovel.codigo)',
                        @index-aberto='atualizarRestricaoMapaCars',
                        :habilitar-zoom-restricao='true'
                    )

            section.mb-3(v-if='consultaRealizada')
                div(
                    v-if='!dadosCar.length && territorio.dadosTerritorio.cars && territorio.dadosTerritorio.cars.length'
                )
                    h3.mb-3
                        i.flow.flow-shape.mr-2
                        b {{ $t('mensagens.diagnosticoSocioambiental.carsVinculados') }}

                    div(
                        v-for='(car, index) in territorio.dadosTerritorio.cars',
                        :key='index'
                    )
                        p <b>{{ $t('mensagens.diagnosticoSocioambiental.numeroCar') }}:</b> {{ car.codigo }}
                        p <b>{{ $t('mensagens.diagnosticoSocioambiental.situacao') }}:</b> {{ validaSituacao(car.status) }}

                    .buscarCars
                        el-link(
                            type='primary',
                            :underline='false',
                            @click='buscarDiagnosticoCars'
                        )
                            | {{ $t('mensagens.diagnosticoSocioambiental.realizarDiagnosticoDosCarsVinculados') }}

        .diagnostico-socioambiental__resultado__actions
            BaseButton(
                v-if="consultaRealizada"
                type='primary',
                size='small',
                @click='marcarExportacaoDiagnosticPdf'
            ) {{ $t('mensagens.diagnosticoSocioambiental.marcarParaExportacao') }}

            el-dropdown(v-bind:disabled='loadingPDF' v-if="consultaRealizada")
                BaseButton(
                    type='primary',
                    size='small',
                    @click='!hasDadosConsultaBuffer ? exportarPdfDiagnosticoSocio(false) : undefined'
                )
                    i.lyra-download-socio(v-if='!loadingPDF')
                    i.el-icon-loading(v-if='loadingPDF')
                    span {{ $t('mensagens.diagnosticoSocioambiental.exportarDiagnostico') }}

                el-dropdown-menu.downloadMenu(
                    v-if='hasDadosConsultaBuffer',
                    slot='dropdown'
                )
                    el-dropdown-item
                        BaseButton(
                            type='primary',
                            @click='exportarPdfDiagnosticoSocio(false)',
                            icon='el-icon-download'
                        ) {{ $t('mensagens.diagnosticoSocioambiental.territorio') }}
                    br
                    el-dropdown-item.spaceProximidades
                        BaseButton(
                            type='primary',
                            @click='exportarPdfDiagnosticoSocio(true)',
                            icon='el-icon-download'
                        ) {{ $t('mensagens.diagnosticoSocioambiental.territorioProximidades') }}

    section.diagnostico-socioambiental__mapa.mapa.w-100.h-100
        mapa(
            ref='mapa',
            :showStatesLayers='false',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :height='"100%"',
            :idMapa='"mapaDiagnosticoSocioambiental"',
            :atualizarMapa='true'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import TerritorioService from '@/services/TerritorioService';
import { ProtocolosService } from '@/services/ProtocolosService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { sortBy } from 'lodash';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import StatusCar from '@/constants/StatusCar';

import { retryOperation } from '@/utils/retry-operation';
import { mapActions, mapGetters } from 'vuex';
import EventBus from '@/utils/eventBus';
import formatters from '@/utils/formatters';
import { connect, disconnect, subscribe } from '@/utils/websocket';
import L from 'leaflet';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'DiagnosticoSocioambientalTerritorioView',

    components: {
        Mapa,
        DiagnosticoSocioambiental,
        BaseButton
    },

    data() {
        return {
            territorio: {
                dadosTerritorio: {},
                diagnosticos: [],
                buffer: null
            },
            representantes: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                exibirPopupAcoes: true,
                territorio: true,
                impedirRemocao: true
            },
            pesquisaValida: true,
            areasRestricao: [],
            loadingPDF: false,
            dadosCar: [],
            indexUltimaRestricaoAbertaTerritorio: null,
            indexUltimaRestricaoAbertaTerritorioBuffer: null,
            indexUltimaRestricaoAbertaRepresentante: null,
            indexUltimaRestricaoAbertaCar: null,
            informacoes_gerais: null,
            camadasAtivas: [],
            camadasGeoserver: [],
            dadosConsulta: {},
            pesquisa: '',
            tituloProximidade: '',
            refMapa: null,
            consultaRealizada: false,
            protocolos: [],
            selectedProtocolo: '',
            protocoloUtilizado: '',
            protocoloUtilizadoFormatado: ''
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'ambientePy']),

        hasDadosConsultaBuffer() {
            return this.territorio.buffer !== null;
        },
        ambienteNorthAmerica() {
            return (
                this.usuarioLogado &&
                this.usuarioLogado.paisGrupo === AmbientesEmpresas.NORTE_AMERICA
            );
        },
        exibirAreaAgricultavel() {
            if (this.ambientePy) {
                return this.informacoes_gerais.areaAgricultavelHaTotal !== 0;
            }
            if (this.ambienteNorthAmerica) {
                return false;
            }

            return true;
        },
        areaLabel() {
            if (this.ambienteNorthAmerica) {
                if (this.$te('mensagens.diagnosticoSocioambiental.areaAcre')) {
                    return this.$t('mensagens.diagnosticoSocioambiental.areaAcre');
                }
                return (this.$t('mensagens.diagnosticoSocioambiental.area') || 'Área') + ' (acres)';
            }
            return this.$t('mensagens.diagnosticoSocioambiental.areaHa');
        },
        areaValue() {
            if (this.ambienteNorthAmerica) {
                return this.informacoes_gerais.area_ac;
            }
            return this.informacoes_gerais.area_ha;
        }
    },

    created() {
        EventBus.$off('mapa:buffer-click');
        this.$nextTick(function() {
            EventBus.$on('mapa:buffer-click', this.bufferClick);
        });
    },

    async mounted() {
        await this.buscarProtocolosPorUsuario();
        this.refMapa = this.$refs.mapa;
        this.$bus.$on('mapa:camadas-ativas-diagnostico', data => {
            this.camadasAtivas = [];
            data.map(layer => {
                this.camadasAtivas.push(layer.layerName);
            });
        });

        const idTerritorio = this.$route.params.idTerritorio;

        await this.buscarDadosTerritorio(idTerritorio);
        
        if (this.protocolos.length <= 1) {
            this.$bus.$emit('mapa:show-buffer', true);
            this.buscarDiagnostico();
            this.consultaRealizada = true;
        }
    },

    methods: {
        ...mapActions(['setMarcarExportar_PDF']),

        validaSituacao(situacao) {
            return StatusCar[situacao];
        },

        getCar(car) {
            if (car.toUpperCase().startsWith('PA')) {
                return car;
            }
        },

        async bufferClick() {
            try {
                const response =
                    await DiagnosticoSocioambientalService.analisarBuffer(
                        [
                            JSON.stringify(
                                this.territorio.dadosTerritorio.geometria
                            )
                        ],
                        this.territorio.idDiagnosticoSocioambiental,
                        this.selectedProtocolo ? this.selectedProtocolo : null
                    );

                const diagnosticos = [];
                response.data.dados.forEach(d =>
                    d.forEach(t => {
                        diagnosticos.push(t);
                    })
                );

                const geometrias = [];
                response.data.geometrias.forEach(g => {
                    geometrias.push(JSON.parse(g));
                });

                this.territorio.buffer = {
                    diagnosticos:
                        this.ordenarDiagnosticoPorCamada(diagnosticos),
                    geometria: geometrias,
                    habilitarAlertaProximidade: response.data.habilitarAlertaProximidade
                };

                this.tituloProximidade = response.data.tituloProximidade;

                this.mostrarLayersBufferMapa();
            } catch (e) {
                this.$notify.error({
                    message: 'Erro ao buscar dados do buffer'
                });
            }
        },

        buscarDiagnostico() {
            const idTerritorio = this.$route.params.idTerritorio;
            this.buscarDiagnosticoRepresentantes(idTerritorio)
                .then(() => {
                    this.$bus.$emit('mapa:show-buffer', true);
                    this.consultaRealizada = true;
                });
        },

        voltar() {
            if (this.consultaRealizada) {
                this.resetarParaSelecaoDeProtocolo();
            } else {
                this.$router.go(-1);
            }
        },

        resetarParaSelecaoDeProtocolo() {
            this.consultaRealizada = false;
            this.territorio.diagnosticos = [];
            this.territorio.buffer = null;
            this.territorio.idDiagnosticoSocioambiental = null;
            this.representantes = [];
            this.dadosCar = [];
            this.informacoes_gerais = null;
            this.areasRestricao = [];
            this.tituloProximidade = '';
            this.protocoloUtilizado = '';
            this.protocoloUtilizadoFormatado = '';
            this.indexUltimaRestricaoAbertaTerritorio = null;
            this.indexUltimaRestricaoAbertaTerritorioBuffer = null;
            this.indexUltimaRestricaoAbertaRepresentante = null;
            this.indexUltimaRestricaoAbertaCar = null;
            this.layersMaps = [];
            this.configureLayersMapa();
            this.$bus.$emit('mapa:show-buffer', false);
        },

        configureLayersMapa() {
            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área Monitorada',
                geoJson: this.territorio.dadosTerritorio.geometria,
                tooltip: this.$t('mensagens.diagnosticoSocioambiental.territorio') + ': ' + this.territorio.dadosTerritorio.nome,
                featureGroup: true
            };

            this.layersMaps.push(layerAreaMonitorada);
        },

        mostrarLayersBufferMapa() {
            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área Monitorada',
                geoJson: this.territorio.buffer.geometria,
                featureGroup: true
            };

            this.layersMaps.push(layerAreaMonitorada);
            this.$bus.$emit('mapa:show-buffer', false);
        },

        carVinculadoLayersMapa(value, car) {
            let layerAreaMonitorada = {
                style: getEstiloGeometria('car'),
                name: 'Car Vinculado',
                geoJson: value,
                tooltip: 'Car: ' + car,
                featureGroup: true
            };

            this.layersMaps.push(layerAreaMonitorada);
        },

        carsVinculadosLayersMapa(dadosCar) {
            dadosCar.forEach(dadoCar => {
                let layerAreaMonitorada = {
                    style: getEstiloGeometria('car'),
                    name: 'Car Vinculado',
                    geoJson: dadoCar.imovel.geometria,
                    tooltip: 'Car: ' + dadoCar.imovel.codigo,
                    featureGroup: true
                };
                this.layersMaps.push(layerAreaMonitorada);
            });
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, restricao) {
            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;

            this.areasRestricao.areas.forEach((area, index) => {
                this.layersMaps.push({
                    style: {
                        color: 'red',
                        weight: 1,
                        fill: true,
                        opacity: opacidade,
                        fillOpacity: opacidade
                    },
                    name: `AreaDiagnostico ${index}`,
                    tagRestricao,
                    group,
                    geoJson: area
                });

                const pin = L.icon({
                    iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.layersMaps.push({
                    name: `CentroidDiagnostico ${index}`,
                    icon: pin,
                    tagRestricao,
                    group,
                    geoJson: centroidFromGeoJSON.get(area)
                });
            });
        },

        async exportarPdfDiagnosticoSocio(buffer) {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message:
                        'Não foi possível se conectar na api para realizar o download do pdf!'
                });
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName = this.$t('mensagens.diagnosticoSocioambiental.pdfTitulo');
                                link.href = linkSource;
                                link.download = fileName;
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error({
                                    message: 'Não foi possível exportar o pdf!'
                                });
                            }
                            this.loadingPDF = false;
                            disconnect();
                        }
                    );
                    this.loadingPDF = true;
                    const idTerritorio = this.$route.params.idTerritorio;
                    const params = {
                        idTerritorio,
                        idDiagnostico: this.territorio.idDiagnosticoSocioambiental,
                        tipoDocumento: 'TERRITORIO',
                        camadas: this.camadasAtivas,
                        buffer: buffer
                            ? JSON.stringify(this.territorio.buffer.geometria)
                            : null,
                        cars: !!this.dadosCar.length,
                        protocolo: this.protocoloUtilizado
                    };

                    const dados = [];
                    dados.push(params);

                    retryOperation(
                        DiagnosticoSocioambientalService.exportarPdf,
                        dados,
                        5000,
                        10
                    );
                } catch (error) {
                    this.$notify.error({
                        message: 'Não foi possível exportar o pdf!'
                    });
                    disconnect();
                }
            } else {
                this.$notify.error({
                    message: 'Usuário deslogado!'
                });
                disconnect();
            }
        },

        alterarNomeCamada(dadosCar) {
            dadosCar.forEach(dadoCar => {
                dadoCar.diagnosticos.forEach(diagnostico => {
                    if (diagnostico.camada.nome === 'Áreas embargadas') {
                        diagnostico.camada.nome = 'Áreas Embargadas (IBAMA)';
                    } else if (
                        diagnostico.camada.nome === 'Monitoramento Desmatamento'
                    ) {
                        diagnostico.camada.nome = 'Desmatamento Lyra';
                    }
                });
            });

            return dadosCar;
        },

        ordenarDiagnosticoPorCamada(diagnosticos) {
            diagnosticos.forEach(diagnostico => {
                if (diagnostico.camada.nome === 'Áreas embargadas') {
                    diagnostico.camada.nome = 'Áreas embargadas (IBAMA)';
                } else if (
                    diagnostico.camada.nome === 'Monitoramento Desmatamento'
                ) {
                    diagnostico.camada.nome = 'Desmatamento Lyra';
                }
            });

            return sortBy(diagnosticos, [
                diagnostico => diagnostico.camada.codigo
            ]);
        },

        atualizarRestricaoMapa(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const tagRestricaoRemove = `${this.indexUltimaRestricaoAbertaTerritorio}-territorio`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );
            this.layersMaps = this.layersMaps.filter(
                l => !l.name.includes('CentroidDiagnostico')
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaTerritorio = indexCollapseRow;
                this.areasRestricao = {
                    areas: this.territorio.diagnosticos[indexCollapseRow]
                        .geometria,
                    camada: this.territorio.diagnosticos[indexCollapseRow]
                        .camada
                };

                const tagRestricaoAdd = `${indexCollapseRow}-territorio`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        atualizarRestricaoBufferMapa(
            restricao,
            indexCollapse,
            indexCollapseRow
        ) {
            this.areasRestricao = [];

            const tagRestricaoRemove = `${this.indexUltimaRestricaoAbertaTerritorioBuffer}-territorio`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaTerritorioBuffer =
                    indexCollapseRow;

                this.areasRestricao = {
                    areas: this.territorio.buffer.diagnosticos[
                        indexCollapseRow
                    ].resultados.map(
                        resultado => resultado.geometry || resultado.geometria
                    ),
                    camada: this.territorio.buffer.diagnosticos[
                        indexCollapseRow
                    ].camada
                };

                const tagRestricaoAdd = `${indexCollapseRow}-territorio`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        atualizarRestricaoMapaCpf(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaRepresentante != null
                    ? this.indexUltimaRestricaoAbertaRepresentante
                    : indexCollapseRow;
            const tagRestricaoRemove = `${indexCollapse}-representante-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaRepresentante = indexCollapseRow;

                if (
                    this.representantes[indexCollapse].diagnostico[
                        indexCollapseRow
                    ]
                ) {
                    this.areasRestricao = {
                        areas: this.representantes[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.representantes[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-representante-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        atualizarRestricaoMapaCars(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaCar !== null
                    ? this.indexUltimaRestricaoAbertaCar
                    : indexCollapseRow;

            const tagRestricaoRemove = `${indexCollapse}-car-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );
            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaCar = indexCollapseRow;
                if (
                    this.dadosCar[indexCollapse].diagnosticos[indexCollapseRow]
                ) {
                    this.areasRestricao = {
                        areas: this.dadosCar[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.dadosCar[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-car-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },
        marcarExportacaoDiagnosticPdf() {
            const documento = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: this.$route.params.idTerritorio,
                idDiagnostico: this.territorio.idDiagnosticoSocioambiental,
                nome: this.territorio.dadosTerritorio.nome,
                tipoDocumento: 'TERRITORIO',
                documento: null,
                camadas: this.camadasAtivas,
                buffer: this.territorio.buffer
                    ? JSON.stringify(this.territorio.buffer.geometria)
                    : null,
                cars: !!this.dadosCar.length,
                protocolo: this.protocoloUtilizado,
                protocoloFormatado: this.protocoloUtilizadoFormatado
            };

            this.setMarcarExportar_PDF(documento);
        },

        async buscarDadosTerritorio(idTerritorio) {
            try {
                const { data } = await TerritorioService.findById(idTerritorio);
                this.territorio.dadosTerritorio = data;
                this.configureLayersMapa();
            } catch (error) {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao buscar os dados do diagnostico socioambiental dos território.'
                });
            }
        },

        buscarDiagnosticoCars() {
            DiagnosticoSocioambientalService.buscarDiagnosticoCarDoTerritorio(
                this.territorio,
                this.selectedProtocolo ? this.selectedProtocolo : null
            )
                .then(responses => {
                    this.carsVinculadosLayersMapa(responses);
                    this.dadosCar = responses.map(response => ({
                        camadaCar: response.camadaCar,
                        imovel: response.imovel,
                        diagnosticos: response.diagnosticos.map(d => ({
                            camada: { ...d.camada, opacidade: 100 },
                            nivelAlerta: d.nivelAlerta,
                            status: d.status,
                            resultados: d.resultados
                        }))
                    }));

                    this.dadosCar = this.alterarNomeCamada(this.dadosCar);
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível buscar o diagnostico socioambiental para alguns CARs.'
                    });
                });
        },

        async buscarDiagnosticoRepresentantes(idTerritorio) {
            try {
                const { data } =
                    await TerritorioService.diagnosticoSocioambiental(
                        idTerritorio,
                        true,
                        this.selectedProtocolo ? this.selectedProtocolo : null
                    );

                if (data.diagnosticoPorRepresentante !== 'null') {
                    this.representantes = data.diagnosticoPorRepresentante.map(
                        representante => ({
                            documento: representante.documento,
                            nomeRepresentante: representante.nomeRepresentante,

                            diagnostico: representante.diagnostico.map(r => ({
                                camada: { ...r.camada, opacidade: 100 },
                                nivelAlerta: r.nivelAlerta,
                                status: r.status,
                                resultados: r.resultados
                            }))
                        })
                    );
                }

                    this.informacoes_gerais = data.informacoes_gerais;
                    this.territorio.idDiagnosticoSocioambiental =
                        data.idDiagnosticoSocioambiental;
                    this.territorio.diagnosticos = data.responseDiagnosticos.map(
                        r => {
                            const resultados = r.resultados.filter(resultado => (
                                !this.ambienteNorthAmerica || Number(resultado?.properties?.areaHa) > 1
                            ));
                            return {
                                camada: { ...r.camada, opacidade: 100 },
                                nivelAlerta: r.nivelAlerta,
                                status: r.status,
                                resultados: resultados.map(r => r.properties),
                                geometria: resultados.map(
                                    r => r.geometria || r.geometry
                                )
                            };
                        }
                    );

                    this.territorio.diagnosticos.sort((a, b) => {
                        return a.camada.nome.localeCompare(b.camada.nome);
                    });

                    this.protocoloUtilizado = data.protocolo;
                    this.protocoloUtilizadoFormatado = data.protocoloDescricao;

                    Object.keys(this.territorio.diagnosticos).forEach(item => {
                        if (
                            this.territorio.diagnosticos[item].camada.nome ===
                            'Áreas embargadas'
                        ) {
                            this.territorio.diagnosticos[item].camada.nome =
                                'Áreas embargadas (IBAMA)';
                        } else if (
                            this.territorio.diagnosticos[item].camada.nome ===
                            'Monitoramento Desmatamento'
                        ) {
                            this.territorio.diagnosticos[item].camada.nome =
                                'Desmatamento Lyra';
                        }
                    });

                    Object.keys(this.representantes).forEach(itemRepresentante => {
                        Object.keys(
                            this.representantes[itemRepresentante].diagnostico
                        ).forEach(i => {
                            if (
                                this.representantes[itemRepresentante].diagnostico[
                                    i
                                ].camada.nome === 'Áreas embargadas'
                            ) {
                                this.representantes[itemRepresentante].diagnostico[
                                    i
                                ].camada.nome = 'Áreas embargadas (IBAMA)';
                            } else if (
                                this.representantes[itemRepresentante].diagnostico[
                                    i
                                ].camada.nome === 'Monitoramento Desmatamento'
                            ) {
                                this.representantes[itemRepresentante].diagnostico[
                                    i
                                ].camada.nome = 'Desmatamento Lyra';
                            }
                        });
                    });
            } catch (error) {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao buscar os dados do diagnostico socioambiental das pessoas.'
                });
            }
        },

        async buscarProtocolosPorUsuario() {
            this.protocolos = await ProtocolosService.buscarProtocolosPorUsuario();
            this.selectedProtocolo = this.protocolos.find(p => p.protocoloPadrao === true).codigo;
        },

        formatNumber(input, decimalPlaces) {
            return formatters.formatNumber(input, decimalPlaces);
        }
    }
};
</script>

<style lang='scss'>
.spaceProximidades {
    margin-top: 5px;
}

.diagnostico-socioambiental__resultado__actions {
    display: flex;
    justify-content: space-between;
    margin-top: 1.2rem;
}

.card-socioambiental {
    width: 700px;
    background-color: var(--white);
    border: 0;

    padding: 16px;
    overflow: auto;

    header {
        h1 {
            margin-left: 2px;
            margin-bottom: 16px;
        }

        .voltar {
            margin-left: -10px;
            margin-right: 5px;
        }

        .voltar:hover {
            cursor: pointer;
        }
    }

    .dados {
        min-height: 700px;
    }

    .dados-label {
        margin-bottom: 5px;

        b {
            padding-left: 5px;
        }
    }
}

@media (max-width: 900px) {
    #diagnostico-socioambiental-view {
        flex-direction: column;
    }

    .card-socioambiental {
        height: 400px;
        width: 100%;

        .vazio {
            height: 60px;
        }
    }
}

.downloadMenu {
    min-width: 180px;
}

.el-dropdown-link-exportar {
    border: 1px solid #babac9;
    padding: 10px 20px;
    color: #19194b;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    font-size: 13px !important;
}

.el-dropdown-link-exportar:hover {
    background-color: #e8e8ed;
}

.downloadButton {
    background: transparent !important;
    border: none !important;
    text-align: left !important;
    padding: 0 !important;
}

.exportar-btn {
    display: flex;
    justify-content: space-between;
}

.buscarCars {
    button {
        background: transparent !important;
        border: none !important;
        padding: 0;
        color: blue;
        text-decoration: underline;
    }
}

.cars * {
    font-size: 1rem;
}

.informacoes-gerais {
    font-size: 13px !important;
    height: 25px !important;
    font-weight: 500;
}

.tela-cheia:has(#add-new-territorio) {
    height: auto;
    width: calc(100vw - 40px - 70px);
}

.lyra-download-socio {
    cursor: pointer;
    content: '';
    width: 11px;
    height: 11px;
    display: inline-block;
    -webkit-mask: url(../../assets/lyra-icons/svg/download.svg) no-repeat 50%
        50%;
    mask: url(../../assets/lyra-icons/svg/download.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
    background-color: var(--white);
    color: var(--white);
    margin-right: 5px;
}
</style>
